import { useEffect } from "react";
import { Platform } from "react-native";

import { useCheckForUpdatesFunction } from "./useCheckForUpdatesFunction";

export const useCheckForUpdates = () => {
  const checkForUpdatesFunction = useCheckForUpdatesFunction();
  useEffect(() => {
    if (Platform.OS !== "web") {
      checkForUpdatesFunction();
    }
  }, [checkForUpdatesFunction]);
};
